/**
 * `/settings/users` — who has an account on this deployment at all.
 *
 * Distinct from `/settings/organization`, which is about ONE workspace's
 * settings. This is platform-level: every person here owns their own workspace,
 * and adding one adds a tenant rather than a member.
 *
 * The nav entry is hidden for everybody but a platform admin, and the screen
 * itself checks again rather than trusting that — a hidden link is not a
 * permission, and somebody will paste the URL. The server checks a third time,
 * which is the check that actually holds.
 */

import { createFileRoute } from '@tanstack/react-router';
import { RouteErrorPanel } from '../../../components/route-error-boundary.tsx';
import { UsersPanel } from '../../../components/settings/users-panel.tsx';

export const Route = createFileRoute('/_authed/settings/users')({
  component: UsersPanel,
  errorComponent: RouteErrorPanel,
});
